export default "__VITE_ASSET__6414bfd7__"